export default "__VITE_ASSET__BTWLmBow__"